/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.VendorFilter = (function() {

    /**
     * Namespace VendorFilter.
     * @exports VendorFilter
     * @namespace
     */
    var VendorFilter = {};

    VendorFilter.VendorFilter = (function() {

        /**
         * Properties of a VendorFilter.
         * @memberof VendorFilter
         * @interface IVendorFilter
         * @property {string|null} [name] VendorFilter name
         * @property {string|null} [street] VendorFilter street
         * @property {string|null} [suburb] VendorFilter suburb
         * @property {string|null} [abn] VendorFilter abn
         * @property {number|null} [active] VendorFilter active
         * @property {string|null} [sortColumn] VendorFilter sortColumn
         * @property {string|null} [sortOrder] VendorFilter sortOrder
         * @property {number|null} [pageIndex] VendorFilter pageIndex
         * @property {number|null} [pageSize] VendorFilter pageSize
         */

        /**
         * Constructs a new VendorFilter.
         * @memberof VendorFilter
         * @classdesc Represents a VendorFilter.
         * @implements IVendorFilter
         * @constructor
         * @param {VendorFilter.IVendorFilter=} [p] Properties to set
         */
        function VendorFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * VendorFilter name.
         * @member {string|null|undefined} name
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        VendorFilter.prototype.name = null;

        /**
         * VendorFilter street.
         * @member {string|null|undefined} street
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        VendorFilter.prototype.street = null;

        /**
         * VendorFilter suburb.
         * @member {string|null|undefined} suburb
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        VendorFilter.prototype.suburb = null;

        /**
         * VendorFilter abn.
         * @member {string|null|undefined} abn
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        VendorFilter.prototype.abn = null;

        /**
         * VendorFilter active.
         * @member {number|null|undefined} active
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        VendorFilter.prototype.active = null;

        /**
         * VendorFilter sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        VendorFilter.prototype.sortColumn = null;

        /**
         * VendorFilter sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        VendorFilter.prototype.sortOrder = null;

        /**
         * VendorFilter pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        VendorFilter.prototype.pageIndex = null;

        /**
         * VendorFilter pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        VendorFilter.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * VendorFilter _name.
         * @member {"name"|undefined} _name
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        Object.defineProperty(VendorFilter.prototype, "_name", {
            get: $util.oneOfGetter($oneOfFields = ["name"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorFilter _street.
         * @member {"street"|undefined} _street
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        Object.defineProperty(VendorFilter.prototype, "_street", {
            get: $util.oneOfGetter($oneOfFields = ["street"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorFilter _suburb.
         * @member {"suburb"|undefined} _suburb
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        Object.defineProperty(VendorFilter.prototype, "_suburb", {
            get: $util.oneOfGetter($oneOfFields = ["suburb"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorFilter _abn.
         * @member {"abn"|undefined} _abn
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        Object.defineProperty(VendorFilter.prototype, "_abn", {
            get: $util.oneOfGetter($oneOfFields = ["abn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorFilter _active.
         * @member {"active"|undefined} _active
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        Object.defineProperty(VendorFilter.prototype, "_active", {
            get: $util.oneOfGetter($oneOfFields = ["active"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorFilter _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        Object.defineProperty(VendorFilter.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorFilter _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        Object.defineProperty(VendorFilter.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorFilter _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        Object.defineProperty(VendorFilter.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * VendorFilter _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof VendorFilter.VendorFilter
         * @instance
         */
        Object.defineProperty(VendorFilter.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified VendorFilter message. Does not implicitly {@link VendorFilter.VendorFilter.verify|verify} messages.
         * @function encode
         * @memberof VendorFilter.VendorFilter
         * @static
         * @param {VendorFilter.IVendorFilter} m VendorFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VendorFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.street != null && Object.hasOwnProperty.call(m, "street"))
                w.uint32(18).string(m.street);
            if (m.suburb != null && Object.hasOwnProperty.call(m, "suburb"))
                w.uint32(26).string(m.suburb);
            if (m.abn != null && Object.hasOwnProperty.call(m, "abn"))
                w.uint32(34).string(m.abn);
            if (m.active != null && Object.hasOwnProperty.call(m, "active"))
                w.uint32(40).int32(m.active);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(50).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(58).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(64).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(72).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified VendorFilter message, length delimited. Does not implicitly {@link VendorFilter.VendorFilter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof VendorFilter.VendorFilter
         * @static
         * @param {VendorFilter.IVendorFilter} message VendorFilter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VendorFilter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VendorFilter message from the specified reader or buffer.
         * @function decode
         * @memberof VendorFilter.VendorFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {VendorFilter.VendorFilter} VendorFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VendorFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.VendorFilter.VendorFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.street = r.string();
                    break;
                case 3:
                    m.suburb = r.string();
                    break;
                case 4:
                    m.abn = r.string();
                    break;
                case 5:
                    m.active = r.int32();
                    break;
                case 6:
                    m.sortColumn = r.string();
                    break;
                case 7:
                    m.sortOrder = r.string();
                    break;
                case 8:
                    m.pageIndex = r.int32();
                    break;
                case 9:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a VendorFilter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof VendorFilter.VendorFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {VendorFilter.VendorFilter} VendorFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VendorFilter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return VendorFilter;
    })();

    return VendorFilter;
})();

module.exports = $root;
